module.exports = __webpack_public_path__ + "img/bus-b.500d572c.png";